import { TSimpleReviewCount } from '@/entities/room'
import { REVIEW_ILLUST_MAP } from '@/features/review-contract'
import { Illust } from '@/shared/ui'

import { SubHeading } from '../common'

type Props = {
  hostSimpleReview: TSimpleReviewCount[]
}

export const Review = ({ hostSimpleReview }: Props) => {
  const hasReview = hostSimpleReview.length > 0

  if (!hasReview) {
    return null
  }

  return (
    <div className="space-y-3">
      <SubHeading className="typo-body2">호스트가 받은 후기</SubHeading>
      <ul className="space-y-3.5">
        {hostSimpleReview.slice(0, 2).map(review => (
          <li
            key={review.simpleReviewTemplateId}
            className="flex items-center gap-4"
          >
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-purple-50">
              <Illust
                name={REVIEW_ILLUST_MAP[review.simpleReviewTemplateCode]}
                size={27}
                active
              />
            </div>
            <div className="typo-label1 flex items-center gap-2 text-gray-900">
              <span className="font-normal">{review.content}</span>
              <span className="font-semibold">{review.count}</span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}
